import { BaseResponse } from "../../../../../../../types/api/api.types";
import { USERS_ENDPOINTS } from "../../../../../../../utils/api/endpoints/usersEndpoints";
import { AddSubUserFormSchema } from "./AddSubUserENTForm.types";

const PREFIX = '[addSubUserENTQuery]'

export const ADD_SUB_USER_ENT_QUERY_KEY = 'ADD_SUB_USER_ENT'

export const addSubUserENTQuery = async (data: AddSubUserFormSchema) => {
  console.log(PREFIX, `Requesting add sub user ENT...`);
  const response = await USERS_ENDPOINTS.addSubUsersENT(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received add sub user ENT response.`);
  return json as BaseResponse;
}